import { render } from "./TheSelect.vue?vue&type=template&id=b3e036a6"
import script from "./TheSelect.vue?vue&type=script&lang=js"
export * from "./TheSelect.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__